﻿import React, { useState, useEffect } from 'react';
import { Asset } from '../models/asset';
import { IcAsset } from '../models/ic-asset';
import { IcInstrumentData } from '../models/ic-instrument-data';
import { NumberBoxComponent } from './NumberBoxComponent';
import { ItemBasicInformation } from '../models/item-basic-information';
import ItemBasicInformationDialog from './ItemBasicInformationDialog';
import { Button } from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';
import { CrudFunctions } from '../utilities/crud-functions';
import { BenchSheetTechnologyType } from '../models/enums';
import { FieldUpdate } from '../models/field-update';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import SecondaryBenchSheetInstrument from './SecondaryBenchSheetInstrument';

//temp
const injectionVolumeUnits = [
    { id: 1, unit: 'mL' },
    { id: 9, unit: 'µL' }
];

let key = 1;

export interface Props {
    benchSheetId: string;
    isReadOnly?: boolean;
}

export default function IcInstrument(props: Props) {
    const [instruments, setInstruments] =
        useState<Asset[]>();

    const [instrument, setInstrument] =
        useState<IcAsset>();

    const [instrumentId, setInstrumentId] =
        useState<string>();

    const [instrumentData, setInstrumentData] =
        useState<IcInstrumentData>();

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [auditInformationDialogVisible, setAuditInformationDialogVisible] =
        useState<boolean>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [dataLoaded, setDataLoaded] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, [props.benchSheetId]);

    useEffect(() => {
        setInstrumentOnLoad();
    }, [instrumentData]);

    useEffect(() => {
        getMatchingInstrument();
    }, [instrumentId]);

    key++;

    return (
        <div>
            <div className="lq-header pw-margin-top-05">
                <div className="lq-header-title">IC Instrument</div>
                <div className="title-bar-spacer" />
                <div>
                    <Button className="title-bar-button"
                        text="" icon="info" type="success"
                        hint="item information"
                        onClick={showInformationDialog} />
                </div>
            </div>

            <SecondaryBenchSheetInstrument
                benchSheetId={props.benchSheetId}
                isReadOnly={props.isReadOnly}
                technology={BenchSheetTechnologyType.IonChromatography}
                showHeader={false}
            />

            <div className="pw-form-section">
                <div className="pw-comp-row">
                    <div className="pw-form-unit pw-comp-15">
                        <div className="pw-form-unit-label">Injection Volume</div>
                        <NumberBoxComponent readOnly={props.isReadOnly}
                            id="injectionVolume"
                            unitId="injectionVolumeUom"
                            showUnits={true}
                            cid="4D43E433-2CDC-41EC-9DFD-6786ADEDADEE"
                            uoms={injectionVolumeUnits}
                            value={instrumentData && instrumentData.injectionVolume ?
                                instrumentData.injectionVolume : undefined}
                            selectedUom={instrumentData && instrumentData.injectionVolumeUom ?
                                instrumentData.injectionVolumeUom : 0}
                            onUomChanged={onInjectionVolumeUomValueChanged}
                            onValueChanged={onValueChanged} />
                    </div>

                    <div className="pw-form-unit pw-comp-15 pw-margin-left-1">
                        <div className="pw-form-unit-label">System Flow Rate</div>
                        <NumberBoxComponent id="systemFlowRate" readOnly={props.isReadOnly}
                            fixedUnit={'mL/min'} onValueChanged={onValueChanged}
                            value={instrumentData && instrumentData.systemFlowRate ?
                                instrumentData.systemFlowRate : undefined} />
                    </div>
                </div>

                {/*
                <div className="pw-flex-wrapped-row-section">
                    <div id="instrument-left-pane">
                        <InstrumentInformation instrument={instrument} />
                    </div>

                    <div id="instrument-right-pane">
                        <div className="pw-comp-row">
                            <div className="pw-form-unit pw-comp-15">
                                <label className="pw-form-unit-label">System Flow Rate</label>
                                <NumberBoxComponent id="systemFlowRate" readOnly={props.isReadOnly}
                                    fixedUnit={'mL/min'} onValueChanged={onValueChanged}
                                    value={instrumentData && instrumentData.systemFlowRate ?
                                        instrumentData.systemFlowRate : undefined} />
                            </div>
                        </div>
                    </div>
                </div>
                */}
            </div>

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width={'25rem'}
                    height={'21rem'}
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    function getMatchingInstrument() {
        if (instruments && instrumentId) {
            const matchingInstrument = instruments.find(i => i.assetId === instrumentId);

            console.log("matchingInstrument:");
            console.log(matchingInstrument);

            if (matchingInstrument)
                setInstrument(matchingInstrument);
        }
    }


    function setInstrumentOnLoad() {
        console.log("setInstrumentOnLoad");

        if (instrumentData && instrumentData.instrumentId && instruments) {
            let matchingInstrument = instruments.find(i => i.assetId === instrumentData.instrumentId);

            if (matchingInstrument)
                setInstrument(matchingInstrument);
        }
    }

    async function onValueChanged(e: any) {
        if (!dataLoaded)
            return;

        if (e.event && e.event.data && e.event.data.prop) {
            const caller = e.event.data.prop;

            setInstrumentData({ ...instrumentData, [caller]: e.value })

            let entity = caller === "systemFlowRate" ? "IonChromatographyBenchSheets" : "BenchSheets";

            let fieldUpdate: FieldUpdate = {
                entity: entity,
                field: caller,
                value: e.value,
                rowId: props.benchSheetId
            };

            //todo: also set UOMs (which are fixed but we want in the database anyway)
            await updateIcBenchSheetField(fieldUpdate)
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Updating Instrument");
                });
        }
    }

    async function onInjectionVolumeUomValueChanged(e: any) {
        if (!dataLoaded)
            return;

        if (e.selectedItem && e.selectedItem.id) {
            const val = e.selectedItem.id;

            setInstrumentData({ ...instrumentData, injectionVolumeUom: val })

            let fieldUpdate: FieldUpdate = {
                entity: "BenchSheets",
                field: "injectionVolumeUom",
                value: val,
                rowId: props.benchSheetId
            };

            await updateIcBenchSheetField(fieldUpdate)
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Updating Injection Volume UOM");
                });
        }
    }

    // TODO:
    async function getIcInstrumentData() {
        await CrudFunctions.getData(`benchsheets/icinstrumentdata/${props.benchSheetId}`)
            .then(data => {
                setInstrumentData(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Instrument Data");
            });
    }


    //TODO rework:
    async function getInstruments() {
        //await CrudFunctions.getData(`assets/assets?technologyType={BenchSheetTechnologyType.IonChromatography}`)  
        //    .then(data => {
        //        setInstruments(data);
        //    })
        //    .catch((res) => {
        //        showMessage(res, ModalMessageType.Error, "Error Retrieving Instruments");
        //    });
    }

    async function getInstrumentId() {
        await CrudFunctions.getData(`benchsheets/instrumentidbybenchsheetid/${props.benchSheetId}`)
            .then(data => {
                if (data && !data.isNull && data.value)
                    setInstrumentId(data.value);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Instrument ID");
            });
    }


    async function updateIcBenchSheetField(fieldUpdate: FieldUpdate) {
        return await CrudFunctions.putData("benchsheets/icbenchsheetfield", fieldUpdate);
    }

    function showInformationDialog() {
        if (instrument) {
            let information: ItemBasicInformation = {
                rowPointer: instrument.assetId,
                createTimestamp: instrument.createTimestamp,
                lastModifiedTimestamp: instrument.modifyTimestamp,
                createUser: instrument.createUser,
                modifyUser: instrument.modifyUser
            };

            setItemBasicInformation(information);
            setItemBasicInformationDialogVisible(true);
        }
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    async function getAllData() {
        await Promise.all([
            getInstrumentId(),
            getInstruments(),
            getIcInstrumentData()
        ])
            .then(() => setDataLoaded(true));
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}

